import React from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  CircularProgress
} from '@mui/material'
import styles from './ConfirmDialog.module.scss'

const ConfirmDialog = ({
  open = false,
  onConfirm,
  onCancel,
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmColor = 'primary',
  loading = false,
  maxWidth = 'xs'
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      maxWidth={maxWidth}
      fullWidth
      className={styles.dialog}
      aria-labelledby='confirm-dialog-title'
      aria-describedby={message ? 'confirm-dialog-description' : undefined}
    >
      <DialogTitle id='confirm-dialog-title' className={styles.title}>
        {title}
      </DialogTitle>
      {message && (
        <DialogContent className={styles.content}>
          {typeof message === 'string'
            ? <Typography id='confirm-dialog-description' variant='body1'>{message}</Typography>
            : <div id='confirm-dialog-description'>{message}</div>}
        </DialogContent>
      )}
      <DialogActions className={styles.actions}>
        <Button
          onClick={onCancel}
          disabled={loading}
          className={styles.cancelButton}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant='contained'
          color={confirmColor}
          className={styles.confirmButton}
        >
          {loading && (
            <CircularProgress size={18} className={styles.spinner} />
          )}
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmColor: PropTypes.oneOf(['primary', 'error']),
  loading: PropTypes.bool,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md'])
}

export default ConfirmDialog
